import classNames from 'classnames/bind';
import styles from './CreateTips.module.scss';
import TipForm from '../Form/TipForm';
import { useContext, useEffect, useRef, useState } from 'react';
import { ToastContext } from '../Context/ToastProvider';
import { getData, postData } from '~/helper/apiService';
import { ModalOverLayContext } from '../Context/ModalOverLayProvider';

const cx = classNames.bind(styles);

function CreateTips() {
  const fileInputRef = useRef(null);
  const [key, setKey] = useState('');
  const { addToast } = useContext(ToastContext);
  const { setModalComponentContent } = useContext(ModalOverLayContext);
  const [tipType , setTipType] = useState([]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    // Gửi dữ liệu lên máy chủ hoặc xử lý tại client-side
    const res = await postData('/tips/create', formData);
    if (res.status === 'success') {
      setKey((prev) => prev + 1);
      setModalComponentContent(null);
    }
    addToast(res);
  };

  const handleLoadType = async ()=>{
    const res = await getData("/tips/readtype");
    setTipType(res);
  }
  useEffect(()=>{
    handleLoadType()
  }, [])
  return (
    <div className={cx('wrapper')}>
      <TipForm key={key} titleBtn="Create tip" handleSubmit={handleSubmit} fileInputRef={fileInputRef} types={tipType} />
    </div>
  );
}

export default CreateTips;
